/**
 * Discriminator values for the consolidated managed-catalog table
 * (`catalog_value`). Each value identifies one logical lookup catalog. New
 * catalogs are added here + in CATALOG_TYPE_REGISTRY — no new table or
 * migration required (PD-14226, Option A). Stored as a varchar so the set
 * can grow without a schema change.
 */
export enum CatalogType {
	MerchandiserManufacturer = 'merchandiser_manufacturer',
	MerchandiserModel = 'merchandiser_model',
	/**
	 * Tenant-managed list of client business types (PD-14326). Unlike the
	 * merchandiser catalogs, this one is a SUGGESTION source only —
	 * `client.businessType` stays free-text with no FK, so the integration and
	 * manual entry keep writing raw strings. The catalog values simply seed the
	 * client-form Business Type typeahead alongside values already on clients.
	 */
	ClientBusinessType = 'client_business_type',
	/** Vehicle make (flat parent of vehicle model). PD-14338. */
	VehicleMake = 'vehicle_make',
	/** Vehicle model — child of a make, like merchandiser model. PD-14338. */
	VehicleModel = 'vehicle_model',
}
